(function($) {
  'use strict';

  moko.firebase = {};


  /**
   * 初期化する
   **/
  moko.firebase.init = function() { 
    return gamepedia_accounts.init();
  };

  /**
   * コメントを投稿する
   **/
  moko.firebase.postComment = function( post_id, parent_id, content, user_hash, author_name, comment_url ) {
    var user = firebase.auth().currentUser;
    var db = firebase.firestore();
    return db.collection('comments').add( {
      site : moko.home_url,
      uid : user.uid,
      comment_url : comment_url||null,
      user_hash : user_hash,
      author_name : author_name||null,
      post_id : post_id,
      parent_id : parent_id,
      content : content,
      user_agent : window.navigator.userAgent||null,
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
    });
  };


})(jQuery);
